import React from "react";

interface Props {
  icon?: React.ReactElement;
  title?: string;
  content: string | React.ReactElement;
}
const EventDetailItem: React.FC<Props> = ({ icon, title, content }) => {
  return (
    <div className="d-flex" style={{ gap: 16 }}>
      <div
        className=" d-flex align-items-center"
        style={{ width: 150, gap: 6 }}
      >
        <div>{icon}</div>
        <p className="m-0">{title}</p>
      </div>
      <div>{content}</div>
    </div>
  );
};

export default EventDetailItem;
